// ============================================================
// Hirafi — Module devis : calculs
// ============================================================

import type { QuoteLineItem } from "../types";

/** Calcule le total à partir des lignes de prestation */
export function calcLineItemsTotal(items: Omit<QuoteLineItem, "id" | "quote_id">[]): number {
  return items.reduce((sum, item) => sum + (item.total_price ?? 0), 0);
}

/** Recalcule total_price pour une ligne */
export function calcLineTotal(qty: number, unitPrice: number): number {
  return Math.round(qty * unitPrice * 100) / 100;
}

/** Formate un montant en DZD */
export function formatAmount(amount: number, currency = "DZD"): string {
  return new Intl.NumberFormat("fr-DZ", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

/** Date min pour validité : +3 jours depuis aujourd'hui */
export function minValidUntil(): string {
  const d = new Date();
  d.setDate(d.getDate() + 3);
  return d.toISOString().split("T")[0];
}

/** Date max pour validité : +90 jours depuis aujourd'hui */
export function maxValidUntil(): string {
  const d = new Date();
  d.setDate(d.getDate() + 90);
  return d.toISOString().split("T")[0];
}

/** Date par défaut suggérée : +30 jours */
export function defaultValidUntil(): string {
  const d = new Date();
  d.setDate(d.getDate() + 30);
  return d.toISOString().split("T")[0];
}
